import React from 'react'
import {
  CAvatar,
  CDropdown,
  CDropdownHeader,
  CDropdownDivider,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react'
import { cilAccountLogout, cilUser } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {jwtDecode} from 'jwt-decode'

import userAvatar from './../../assets/images/avatars/user.png'

const AppHeaderDropdown = () => {
  const token = localStorage.getItem("access_token");
  let user_id = null;
  let avatarUrl = userAvatar;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      user_id = decodedToken.user_id;
      if (decodedToken.avatar_url && decodedToken.avatar_url.trim() !== "") {
        avatarUrl = decodedToken.avatar_url;
      }
    } catch (error) {
      console.error("Invalid token", error);
    }
  }
  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0 pe-0" caret={false}>
        <CAvatar src={avatarUrl} size="md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-body-secondary fw-semibold mb-2">Conta</CDropdownHeader>
        <CDropdownItem href={user_id ? `/utilizadores/${user_id}` : '#'}>
          <CIcon icon={cilUser} className="me-2" />
          Perfil
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href="/logout">
          <CIcon icon={cilAccountLogout} className="me-2" />
          Logout
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
